import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { Grid } from "./Grid";
import { SlotsProvider } from "../providers/SlotsProvider";
export const doubleColumnLayoutClasses = {
    root: "MinervaDoubleColumnLayout-root",
    left: "MinervaDoubleColumnLayout-left",
    right: "MinervaDoubleColumnLayout-right",
    main: "MinervaDoubleColumnLayout-main",
};
export const doubleColumnLayoutSlots = {
    left: Grid,
    right: Grid,
    main: Grid,
};
export const DoubleColumnLayout = ({ left, right, slots, slotProps, className, children, ...rest }) => {
    return (_jsx(SlotsProvider, { baseSlots: doubleColumnLayoutSlots, slots: slots, children: ({ left: Left, right: Right, main: Main }) => (_jsxs(Grid, { container: true, height: "100%", width: "100%", className: clsx([className, doubleColumnLayoutClasses.root]), ...rest, children: [left && (_jsx(Left, { item: true, height: "100%", minWidth: 0, ...slotProps?.left, className: clsx([
                        doubleColumnLayoutClasses.left,
                        slotProps?.left?.className,
                    ]), children: left })), _jsx(Main, { item: true, xs: true, height: "100%", minWidth: 0, ...slotProps?.main, className: clsx([
                        doubleColumnLayoutClasses.main,
                        slotProps?.main?.className,
                    ]), children: children }), right && (_jsx(Right, { item: true, height: "100%", minWidth: 0, ...slotProps?.right, className: clsx([
                        doubleColumnLayoutClasses.right,
                        slotProps?.right?.className,
                    ]), children: right }))] })) }));
};
export default DoubleColumnLayout;
//# sourceMappingURL=DoubleColumnLayout.js.map